/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Swal_TextInputs */

const en_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to paste the event(s) based on the current time?`)
};

const fr_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhaitez-vous coller le(s) evenement(s) en fonction de l'heure actuelle ?`)
};

const de_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie die Ereignisse basierend auf der aktuellen Uhrzeit einfügen?`)
};

const it_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desideri incollare l'evento/gli eventi in base all'ora corrente?`)
};

const ru_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хотите вставить событие(я) в соответствии с текущим временем?`)
};

const es_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres pegar el(los) evento(s) según la hora actual?`)
};

const zh_cn2_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您想根据当前时间粘贴事件吗？`)
};

const ja_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の時刻に基づいてイベントを貼り付けますか?`)
};

const hi_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वर्तमान समय के आधार पर इवेंट्स को पेस्ट करना चाहेंगे?`)
};

const pt_pt2_paste_swal_text = /** @type {(inputs: Paste_Swal_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseja colar os eventos com base na hora atual?`)
};

/**
* | output |
* | --- |
* | "Would you like to paste the event(s) based on the current time?" |
*
* @param {Paste_Swal_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_swal_text = /** @type {((inputs?: Paste_Swal_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Swal_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_swal_text(inputs)
	if (locale === "de") return de_paste_swal_text(inputs)
	if (locale === "it") return it_paste_swal_text(inputs)
	if (locale === "ru") return ru_paste_swal_text(inputs)
	if (locale === "es") return es_paste_swal_text(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_swal_text(inputs)
	if (locale === "ja") return ja_paste_swal_text(inputs)
	if (locale === "hi") return hi_paste_swal_text(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_swal_text(inputs)
	return en_paste_swal_text(inputs)
});